export default __webpack_public_path__ + "static/media/past-greece.9ae6b3e1.jpg";